import { render } from "./games_player.vue?vue&type=template&id=6a08c6d4"
import script from "./games_player.vue?vue&type=script&lang=js"
export * from "./games_player.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__